import { useState } from "react";
import svgPaths from "../../imports/svg-acpbwwav25";

// Define the data for all tabs
const journeySteps = [
  "Select your quest",
  "Build your team",
  "Get mentorship",
  "Train and Learn",
  "Build and innovate",
  "Submit and present",
];

// Icons components
function Icon1() {
  return (
    <div className="h-[31.986px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute inset-[2.81%_13.85%_34.69%_2.81%]" data-name="Vector">
        <div className="absolute inset-[-4.5%_-3.37%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 28.4546 21.7907">
            <path d={svgPaths.p1c923c90} stroke="#171A22" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.79923" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Icon2() {
  return (
    <div className="h-[31.986px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute inset-[2.81%_5.52%_38.85%_2.81%]" data-name="Vector">
        <div className="absolute inset-[-4.82%_-3.07%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 31.12 20.4581">
            <path d={svgPaths.p74ff900} stroke="#171A22" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.79923" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Icon3() {
  return (
    <div className="h-[31.986px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute inset-[2.81%_22.19%_34.69%_2.81%]" data-name="Vector">
        <div className="absolute inset-[-4.5%_-3.75%]">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25.789 21.7907">
            <path d={svgPaths.pc36a780} stroke="#171A22" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.79923" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Icon4() {
  return (
    <div className="h-[31.986px] overflow-clip relative shrink-0 w-full" data-name="Icon">
      <div className="absolute inset-[0_19.2%_19.2%_0]" data-name="Vector">
        <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 25.8457 25.8457">
          <path d={svgPaths.p3b7a3e00} fill="#171A22" />
        </svg>
      </div>
    </div>
  );
}

// Tab content data structure
const tabContent = {
  "Select your quest": [
    {
      Icon: Icon1,
      label: "Challenges",
      title: "Browse open innovation challenges",
    },
    {
      Icon: Icon2,
      label: "Categories",
      title: "Filter by technology & industry",
    },
    {
      Icon: Icon3,
      label: "Impact",
      title: "Choose problems worth solving",
    },
    {
      Icon: Icon4,
      label: "Register",
      title: "Sign up for your chosen quest",
    },
  ],
  "Build your team": [
    {
      Icon: Icon1,
      label: "Networking",
      title: "Connect with innovators",
    },
    {
      Icon: Icon2,
      label: "Skills",
      title: "Find complementary talents",
    },
    {
      Icon: Icon3,
      label: "Collaboration",
      title: "Form diverse teams",
    },
    {
      Icon: Icon4,
      label: "Registration",
      title: "Register your team members",
    },
  ],
  "Get mentorship": [
    {
      Icon: Icon1,
      label: "Experts",
      title: "Access industry mentors",
    },
    {
      Icon: Icon2,
      label: "Guidance",
      title: "Schedule 1-on-1 sessions",
    },
    {
      Icon: Icon3,
      label: "Feedback",
      title: "Get expert insights on your idea",
    },
    {
      Icon: Icon4,
      label: "Network",
      title: "Build professional connections",
    },
  ],
  "Train and Learn": [
    {
      Icon: Icon1,
      label: "Learnathon",
      title: "Complete Training Modules",
    },
    {
      Icon: Icon2,
      label: "Cloud Resources",
      title: "Access cloud credits & development tools",
    },
    {
      Icon: Icon3,
      label: "Learn about Jury",
      title: "Understand the judging criteria",
    },
    {
      Icon: Icon4,
      label: "Goal",
      title: "Build products from scratch",
    },
  ],
  "Build and innovate": [
    {
      Icon: Icon1,
      label: "Develop",
      title: "Build your prototype",
    },
    {
      Icon: Icon2,
      label: "Resources",
      title: "Access development tools",
    },
    {
      Icon: Icon3,
      label: "Support",
      title: "Get technical assistance",
    },
    {
      Icon: Icon4,
      label: "Iterate",
      title: "Test and refine your solution",
    },
  ],
  "Submit and present": [
    {
      Icon: Icon1,
      label: "Demo",
      title: "Prepare your presentation",
    },
    {
      Icon: Icon2,
      label: "Submission",
      title: "Submit your final project",
    },
    {
      Icon: Icon3,
      label: "Pitch",
      title: "Present to the jury",
    },
    {
      Icon: Icon4,
      label: "Awards",
      title: "Compete for prizes",
    },
  ],
};

export default function InnovationJourney() {
  const [activeTab, setActiveTab] = useState(3); // "Train and Learn" by default

  const activeStepName = journeySteps[activeTab];
  const activeCards = tabContent[activeStepName as keyof typeof tabContent];

  return (
    <section id="innovation-journey" className="bg-white py-12 lg:py-20">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl lg:text-[48px] leading-tight font-normal text-[#171a22] mb-4 lg:mb-6 text-center">
          Know Your Innovation Journey
        </h2>
        <p className="text-base sm:text-lg lg:text-[24px] leading-relaxed font-light text-[#171a22] mb-10 lg:mb-16 text-center">
          Discover ideas, explore possibilities, and transform creativity into real‑world solutions.
        </p>

        {/* Tabs - Now responsive with wrapping */}
        <div className="mb-10 lg:mb-16">
          <div className="flex flex-wrap justify-center gap-x-2 sm:gap-x-4 md:gap-x-6 lg:gap-x-8 gap-y-3 border-b-2">
            {journeySteps.map((step, i) => (
              <button
                key={i}
                onClick={() => setActiveTab(i)}
                className="relative pb-3 px-2 sm:px-3 transition-all cursor-pointer group"
              >
                <span
                  className={`text-xs sm:text-sm lg:text-base font-medium whitespace-nowrap transition-colors ${
                    i === activeTab ? "text-[#0069A8]" : "text-[#595e6a] hover:text-[#171a22]"
                  }`}
                >
                  {step}
                </span>
                {/* Underline */}
                <div
                  className={`absolute bottom-0 left-0 right-0 h-[2px] transition-all ${
                    i === activeTab ? "bg-[#0069A8] scale-x-100" : "bg-transparent scale-x-0"
                  }`}
                />
              </button>
            ))}
          </div>
        </div>

        {/* Content Grid - 2x2 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 max-w-[880px] mx-auto">
          {activeCards.map((card, i) => {
            const IconComponent = card.Icon;
            return (
              <div
                key={i}
                className="text-center bg-white border border-[#eff0f4] rounded-lg p-6 sm:p-6 lg:p-8 hover:border-[#0069A8]/30 hover:shadow-md transition-all"
              >
                <div className="w-8 h-8 lg:w-9 lg:h-9 mb-4 lg:mb-4 mx-auto">
                  <IconComponent />
                </div>
                <p className="text-xs lg:text-sm leading-5 text-[#595e6a] mb-2 lg:mb-3 uppercase tracking-wide">
                  {card.label}
                </p>
                <h4 className="text-base sm:text-lg lg:text-[20px] leading-snug font-medium text-[#171a22]">
                  {card.title}
                </h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}